// src/components/store/sections/product-cards/Variant89SoftClayWellCrimsonRoseCard.tsx
"use client";

import Image from "next/image";
import Link from "next/link";
import { Star, Plus, Check, Heart } from "lucide-react";
import { UniversalProductCardProps, useCardActions } from "./useCardActions";

export default function Variant89SoftClayWellCrimsonRoseCard({
  product,
  subdomain = "nextlook",
}: UniversalProductCardProps) {
  const {
    productImg,
    productName,
    productUrl,
    categoryName,
    rating,
    currentPrice,
    added,
    wishlisted,
    setWishlisted,
    handleAddToCart,
  } = useCardActions(product, subdomain);

  return (
    <div className="w-full h-full rounded-[32px] p-4 bg-rose-50 border-2 border-white shadow-[6px_6px_16px_rgba(0,0,0,0.06),-6px_-6px_16px_rgba(255,255,255,0.9)] flex flex-col justify-between group transition-all hover:-translate-y-1 select-none">
      <div>
        <div className="flex items-center justify-between mb-2.5">
          <span className="px-2.5 py-0.5 rounded-full bg-white text-rose-700 text-[9px] font-black uppercase tracking-wider shadow-2xs truncate max-w-[130px]">
            {categoryName}
          </span>
          <button
            type="button"
            onClick={() => setWishlisted(!wishlisted)}
            className="w-7 h-7 rounded-xl bg-white shadow-2xs flex items-center justify-center text-slate-400 hover:text-rose-500 cursor-pointer"
          >
            <Heart className={`w-3.5 h-3.5 ${wishlisted ? "fill-rose-500 text-rose-500" : ""}`} />
          </button>
        </div>
        <Link href={productUrl} className="relative w-full h-44 rounded-[24px] bg-white/80 shadow-inner flex items-center justify-center p-3 mb-3 block">
          <Image src={productImg} alt={productName} fill unoptimized className="object-contain p-2 group-hover:scale-110 transition-transform duration-500" />
        </Link>
        <div className="flex items-center gap-1 text-amber-500 text-xs font-bold">
          <Star className="w-3.5 h-3.5 fill-amber-400" />
          <span>{rating.toFixed(1)}</span>
        </div>
        <Link href={productUrl} className="block mt-0.5">
          <h3 className="text-sm font-black text-slate-900 truncate hover:underline">{productName}</h3>
        </Link>
      </div>

      <div className="mt-3 p-2.5 pl-3.5 rounded-2xl bg-white shadow-xs flex items-center justify-between">
        <span className="text-base font-black font-mono text-rose-700">৳{currentPrice.toLocaleString()}</span>
        <button
          type="button"
          onClick={(e) => handleAddToCart(e)}
          className="px-3.5 py-2 rounded-xl bg-rose-600 hover:bg-rose-700 text-white font-black text-[10px] uppercase tracking-wider shadow-xs active:scale-95 transition-all cursor-pointer flex items-center gap-1"
        >
          {added ? <Check className="w-3.5 h-3.5" /> : <Plus className="w-3.5 h-3.5 stroke-[3]" />}
          <span>{added ? "Added" : "Add"}</span>
        </button>
      </div>
    </div>
  );
}
